import React, { ComponentType, lazy } from 'react';
import { Outlet, RouteObject } from 'react-router-dom';
import SignIn from 'routes/SignIn';
import PageNotFound from 'components/common/PageNotFound';
import withRoute, { AnonymousRoute } from 'components/common/Route';
import AppLayout from 'components/common/AppLayout';
import { useLogin } from 'hooks/useLogin';
import { MAINTENANCE_MODE } from 'config/flags';
import signInSecurityRoutes, { SignInSecurityLayout } from './SignInSecurity';
import privacyRoutes, { PrivacyLayout } from './Privacy';

type LazyModulePromise = Promise<{ default: ComponentType<any> }>;

const MyAccount = lazy((): LazyModulePromise => import('components/MyAccount'));
const Profile = lazy((): LazyModulePromise => import('./Profile'));
const TermsAndConditions = lazy(
  (): LazyModulePromise => import('./TermsAndConditions')
);

export const RoutesWithLayout = () => {
  useLogin();

  return (
    <AppLayout showLeftNav={!MAINTENANCE_MODE}>
      <Outlet />
    </AppLayout>
  );
};

const routes: RouteObject[] = [
  {
    path: 'sign-in',
    Component: () => (
      <AnonymousRoute>
        <SignIn />
      </AnonymousRoute>
    ),
  },
  {
    path: '*',
    Component: () => withRoute(MyAccount),
  },
  {
    path: 'profile/*',
    Component: () => withRoute(Profile),
  },
  {
    path: 'signin-security/*',
    Component: () => withRoute(SignInSecurityLayout),
    children: signInSecurityRoutes,
  },
  {
    path: 'privacy-and-data/*',
    Component: () => withRoute(PrivacyLayout),
    children: privacyRoutes,
  },
  {
    path: 'terms-and-conditions/*',
    Component: () => withRoute(TermsAndConditions),
  },
  {
    path: '*',
    Component: () => (
      <AnonymousRoute>
        <PageNotFound />
      </AnonymousRoute>
    ),
  },
];

export default routes;
